import React, { useState, useEffect } from 'react';
import './form_willow_cv.css';
import SubmissionModal from '../../components/SubmissionModal';
import axios from 'axios';

const FormWillowCV = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    file: null
  });
  const [fileName, setFileName] = useState('No files selected');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalState, setModalState] = useState(null);
  const [businessData, setBusinessData] = useState(null);

  useEffect(() => {
    const fetchBusinessData = async () => {
      try {
        const response = await axios.get('https://api.azucarai.com/business/9h8UEN6mTY3Ybtz_gbJ3Mw');
        if (response.data && response.data.content) {
          setBusinessData(response.data.content);
        }
      } catch (error) {
        console.error("Error fetching business data:", error);
      }
    };
    fetchBusinessData();
  }, []);

  // --- FUNCIÓN PARA FORMATEAR TELÉFONO ---
  const formatPhoneNumber = (value) => {
    // Extraer todos los dígitos
    const digits = value.replace(/\D/g, '');

    let baseNumber = digits;
    // Si el primer dígito es un 1, lo tratamos como el prefijo de país y usamos los siguientes 10
    if (digits.startsWith('1')) {
      baseNumber = digits.slice(1);
    }

    const limited = baseNumber.slice(0, 10);

    if (limited.length === 0) {
      return digits.length > 0 ? "+1 " : "";
    }

    let formatted = "+1 ";
    if (limited.length > 0) {
      formatted += `(${limited.slice(0, 3)}`;
    }
    if (limited.length > 3) {
      formatted += `) ${limited.slice(3, 6)}`;
    }
    if (limited.length > 6) {
      formatted += `-${limited.slice(6)}`;
    }

    return formatted;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Formatear teléfono si es el campo phone
    if (name === "phone") {
      const formatted = formatPhoneNumber(value);
      setFormData(prev => ({
        ...prev,
        [name]: formatted
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        file: file
      }));
      setFileName(file.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // Obtener solo los dígitos del teléfono (sin formato) para el backend
      const phoneDigits = formData.phone.replace(/\D/g, '');

      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('phone', phoneDigits); // Enviar solo dígitos sin formato
      formDataToSend.append('email', formData.email);
      if (formData.file) {
        formDataToSend.append('cv', formData.file);
      }

      // Endpoint para enviar el CV a Willow
      const response = await fetch('https://api.azucarai.com/clinic/willow/cv', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setModalState('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          file: null
        });
        setFileName('No files selected');
      } else {
        setModalState('error');
      }
    } catch (error) {
      console.error('Error sending form:', error);
      setModalState('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setModalState(null);
    setIsSubmitting(false);
  };

  return (
    <div className="willow-cv-form-container">
      <SubmissionModal
        state={modalState}
        onClose={handleCloseModal}
        companyName={businessData?.business_name || "Willow"}
        phoneNumber={businessData?.phone_web || businessData?.main_phone || businessData?.phone_google || businessData?.phone_yelp || "+1 (408) 509-0579"}
      />
      <div className="willow-cv-form">
        <h2 className="form-title">Send us your resume</h2>

        <form onSubmit={handleSubmit} className="cv-form">
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              autoComplete="tel"
              maxLength={17}
              className="form-input"
            />
          </div>

          <div className="file-upload-group">
            <div className="file-upload-container">
              <input
                type="file"
                id="cv-file"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                className="file-input"
              />
              <label htmlFor="cv-file" className="file-label">
                Select file
              </label>
              <span className="file-name">{fileName}</span>
            </div>
          </div>



          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send'}
          </button>

          {/* Modal handles status display */}

          <div className='text-center mt-4'>
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=Hr@cbrhr.com"
              target="_blank"
              rel="noopener noreferrer"
              className='text-base text-blue-500 hover:text-blue-700'
            >
              or simply email your resume to Hr@cbrhr.com
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormWillowCV;
